/* Only filters current native rendered cards. Does not fetch or change catalog data. */
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-build-collection-search]').forEach((input) => {
      if (input.dataset.buildSearchReady) return;
      input.dataset.buildSearchReady = 'true';
      const section = input.closest('.kiive-build-collection');
      const cards = [...section.querySelectorAll('.kv-card--build')];
      const status = section.querySelector('[data-build-search-status]');
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase();
        let matches = 0;
        cards.forEach((card) => {
          const matched = !query || card.dataset.buildTitle.toLocaleLowerCase().includes(query);
          card.hidden = !matched;
          if (matched) matches += 1;
        });
        status.hidden = !query;
        status.textContent = query ? `${matches} matching ${matches === 1 ? 'product' : 'products'} on this page` : '';
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
